import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Heading } from 'components/layout/Typography/Typography';

import styles from './Card.module.scss';

const s = classNames.bind(styles);

/**
|--------------------------------------------------
| @component Card
|--------------------------------------------------
*/
export const Card = ({ children, className, padding, withShadow, wrapperElement, marginBottom, marginTop, ...props }) => {
	const cardClassName = s('container', {
		[`container_padding_${padding}`]: padding,
		[`container_marginBottom_${marginBottom}`]: marginBottom,
		[`container_marginTop_${marginTop}`]: marginTop,
		container_withShadow: withShadow,
		[className]: className
	});

	if (wrapperElement === 'li') {
		return (
			<li className={cardClassName} {...props}>
				{children}
			</li>
		);
	}

	return (
		<div className={cardClassName} {...props}>
			{children}
		</div>
	);
};

Card.propTypes = {
	children: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),
	padding: PropTypes.oneOf(['0', '1', '2', '3', '4']),
	marginBottom: PropTypes.oneOf(['0', '05', '1', '15', '2', '25', '3', '4']),
	marginTop: PropTypes.oneOf(['0', '05', '1', '15', '2', '25', '3', '4']),
	withShadow: PropTypes.bool,
	wrapperElement: PropTypes.oneOf(['div', 'li']),
	className: PropTypes.string,
	disabled: PropTypes.bool
};

Card.defaultProps = {
	padding: '2',
	wrapperElement: 'div'
};

/**
|--------------------------------------------------
| @component CardHeadingContainer
|--------------------------------------------------
*/
export const CardHeadingContainer = ({ className, children, borderBottom, marginBottom, marginTop }) => (
	<header
		className={s('headingContainer', {
			[`headingContainer_marginBottom_${marginBottom}`]: marginBottom,
			[`headingContainer_marginTop_${marginTop}`]: marginTop,
			headingContainer_noBorder: !borderBottom,
			[className]: className
		})}
	>
		{children || null}
	</header>
);

CardHeadingContainer.propTypes = {
	marginTop: PropTypes.oneOf(['0', '05', '1', '15', '2', '25', '3', '4']),
	marginBottom: PropTypes.oneOf(['0', '05', '1', '15', '2', '25', '3', '4']),
	className: PropTypes.string,
	borderBottom: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.node, PropTypes.object])
};

CardHeadingContainer.defaultProps = {
	borderBottom: true
};

/**
|--------------------------------------------------
| @component CardHeading
|--------------------------------------------------
*/
export const CardHeading = ({ children, className, marginBottom, marginTop, withEllipsis, disabled }) => (
	<Heading
		type={'h4'}
		className={s('heading', {
			heading_disabled: disabled,
			[className]: className
		})}
		marginBottom={marginBottom}
		marginTop={marginTop}
		withEllipsis={withEllipsis}
	>
		{children}
	</Heading>
);

CardHeading.propTypes = {
	withEllipsis: PropTypes.bool,
	marginTop: PropTypes.oneOf(['0', '05', '1', '15', '2', '25', '3', '4']),
	marginBottom: PropTypes.oneOf(['0', '05', '1', '15', '2', '25', '3', '4']),
	className: PropTypes.string,
	disabled: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.node, PropTypes.object])
};

CardHeading.defaultProps = {
	marginBottom: '0',
	marginTop: '0'
};

export default CardHeadingContainer;
